import { InjectionToken } from '@angular/core';

export let SSO_API_URL = new InjectionToken<string>('sso.api.url');
